const empty = (value) => value === undefined || value === null || (typeof value === 'string' && value.trim() === '') || (Array.isArray(value) && value.length === 0) || value === false;
function requiredMessage(field) {
    const label = 'label' in field && field.label ? `„${field.label}“` : 'diesem Feld';
    if (field.type === 'consent')
        return `Bitte bestätigen Sie ${label}.`;
    if (['select', 'multiSelect', 'radio', 'checkbox'].includes(field.type))
        return `Bitte wählen Sie bei ${label} eine Option.`;
    return `Bitte füllen Sie ${label} aus.`;
}
function validateField(field, value) {
    if ('required' in field && field.required && empty(value))
        return requiredMessage(field);
    if (empty(value))
        return undefined;
    if (field.type === 'email' && (typeof value !== 'string' || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(value)))
        return 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
    if (field.type === 'tel' && (typeof value !== 'string' || !/^[+()\d\s./-]{6,30}$/u.test(value)))
        return 'Bitte geben Sie eine gültige Telefonnummer ein.';
    if (['text', 'email', 'tel', 'textarea', 'hidden'].includes(field.type) && typeof value === 'string') {
        if ('minLength' in field && field.minLength !== undefined && value.length < field.minLength)
            return field.validationMessage ?? `Mindestens ${field.minLength} Zeichen.`;
        if ('maxLength' in field && field.maxLength !== undefined && value.length > field.maxLength)
            return field.validationMessage ?? `Maximal ${field.maxLength} Zeichen.`;
        if ('pattern' in field && field.pattern && !new RegExp(field.pattern, 'u').test(value))
            return field.validationMessage ?? 'Der Wert hat nicht das erwartete Format.';
    }
    if (field.type === 'number') {
        const numeric = typeof value === 'number' ? value : Number(value);
        if (!Number.isFinite(numeric))
            return 'Bitte geben Sie eine gültige Zahl ein.';
        if (field.min !== undefined && numeric < field.min)
            return `Der Wert muss mindestens ${field.min} sein.`;
        if (field.max !== undefined && numeric > field.max)
            return `Der Wert darf höchstens ${field.max} sein.`;
    }
    if ((field.type === 'select' || field.type === 'radio') && !field.options.some((option) => option.value === value))
        return 'Bitte wählen Sie eine gültige Option.';
    if ((field.type === 'multiSelect' || field.type === 'checkbox') && 'options' in field && (!Array.isArray(value) || value.some((entry) => typeof entry !== 'string' || !field.options.some((option) => option.value === entry))))
        return 'Bitte wählen Sie nur gültige Optionen.';
    return undefined;
}
export function validateSubmission(definition, payload) {
    const errors = {};
    const values = [];
    const consents = [];
    for (const field of definition.elements) {
        if (field.type === 'heading' || field.type === 'richtext' || field.type === 'link' || field.type === 'divider' || field.type === 'spacer' || field.type === 'info' || (field.type === 'text' && 'content' in field))
            continue;
        const value = payload[field.id];
        const error = validateField(field, value);
        if (error)
            errors[field.id] = error;
        values.push({ fieldKey: field.id, label: 'label' in field ? field.label : field.id, value: value ?? null });
        if (field.type === 'consent' && value === true)
            consents.push({ fieldKey: field.id, consentText: field.consentText, textVersion: field.textVersion });
    }
    return { success: Object.keys(errors).length === 0, values, errors, consents };
}
//# sourceMappingURL=validation.js.map